export default __webpack_public_path__ + "static/media/blog-img252.78a12fd5.jpg";